import {ChangeDetectionStrategy, Component, Inject} from '@angular/core';
import {ComponentCatalogOptions, OPTIONS} from '../../options.token';

@Component({
  selector: 'cc-nav-drawer',
  templateUrl: './nav-drawer.component.html',
  styleUrls: ['./nav-drawer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavDrawerComponent {
  constructor(@Inject(OPTIONS) public readonly config: ComponentCatalogOptions) {
  }
}
